/**
 * Analytics API Service
 */
import apiClient from './client';
import type { AnalyticsData } from '../../types';

let _analyticsInflight: Promise<AnalyticsData> | null = null;

export const getUserAnalytics = (): Promise<AnalyticsData> => {
  if (_analyticsInflight) return _analyticsInflight;
  _analyticsInflight = apiClient
    .get('/api/analytics')
    .then((r) => r.data)
    .finally(() => { _analyticsInflight = null; });
  return _analyticsInflight;
};

export const testConnection = async (): Promise<any> => {
  try {
    const response = await apiClient.get('/api/test');
    return response.data;
  } catch (error) {
    console.error('API connection failed:', error);
    throw error;
  }
};
